import { apiService } from '../../components/Config/api.service';

/**
 * Ouvre un justificatif d'une demande dans un nouvel onglet (Yros/Kavero#18).
 *
 * L'onglet s'ouvre AVANT l'appel réseau, dans le geste de l'utilisateur :
 * ouvert après un `await`, il serait bloqué comme une fenêtre surgissante. Si
 * le navigateur le refuse quand même, le fichier se télécharge.
 *
 * Partagé par l'espace du salarié et la supervision RH : c'est le même fichier,
 * servi par la même route, que le proxy ne laisse sortir qu'en PDF, JPEG ou PNG.
 */
export async function ouvrirJustificatif(demande, piece) {
  const onglet = window.open('', '_blank');
  try {
    const blob = await apiService.lireJustificatif(demande.id, demande.type, piece.id);
    const url = window.URL.createObjectURL(blob);
    if (onglet) {
      // Le nouvel onglet n'a pas à pouvoir piloter celui-ci.
      onglet.opener = null;
      onglet.location.href = url;
      // L'onglet a lu le blob en s'ouvrant : la mémoire se rend plus tard,
      // pour ne pas couper un chargement en cours.
      setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    } else {
      window.URL.revokeObjectURL(url);
      apiService.downloadBlob(blob, piece.nom || 'justificatif');
    }
  } catch (erreur) {
    if (onglet) onglet.close();
    throw erreur;
  }
}
